export const useHelpers = () => {

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getPreviousMonthDate = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number); // Divide la fecha en año, mes y día
    
        // Crear una nueva fecha con el año, mes y día actuales
        const date = new Date(year, month - 1, day); // Restamos 1 al mes porque los meses están basados en 0
    
        // Restamos un mes usando setMonth
        date.setMonth(date.getMonth() - 1);
    
        // Si el día actual es mayor al último día del mes anterior, ajusta el día al último día disponible
        if (day > new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()) {
            date.setDate(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate());
        }
    
        const newYear = date.getFullYear();
        const newMonth = date.getMonth() + 1; // Se suma 1 porque los meses están basados en 0
        const newDay = date.getDate();
    
        // Formateamos la fecha en 'YYYY-MM-DD' agregando ceros si es necesario
        return `${newYear}-${newMonth < 10 ? `0${newMonth}` : newMonth}-${newDay < 10 ? `0${newDay}` : newDay}`;
    };

    const getNextMonthDate = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number); // Divide la fecha en año, mes y día
    
        // Crear una nueva fecha con el año, mes y día actuales
        const date = new Date(year, month - 1, day); // Restamos 1 al mes porque los meses están basados en 0
    
        // Sumamos un mes usando setMonth
        date.setMonth(date.getMonth() + 2);
    
        // Si el día actual es mayor al último día del mes siguiente, ajusta el día al último día disponible
        if (day > new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()) {
            date.setDate(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate());
        }
    
        const newYear = date.getFullYear();
        const newMonth = date.getMonth() + 1; // Se suma 1 porque los meses están basados en 0
        const newDay = date.getDate();
    
        // Formateamos la fecha en 'YYYY-MM-DD' agregando ceros si es necesario
        return `${newYear}-${newMonth < 10 ? `0${newMonth}` : newMonth}-${newDay < 10 ? `0${newDay}` : newDay}`;
    };

    const fecha_actual = getCurrentDate()
    
    return Object.freeze({
        getCurrentDate,
        getPreviousMonthDate,
        getNextMonthDate,
        fecha_actual
    })
}